const CURRENCIES = [
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'GBP',
    value: 'GBP',
  },
  {
    label: 'ARS',
    value: 'ARS',
  },
  {
    label: 'CLP',
    value: 'CLP',
  },
  {
    label: 'BRL',
    value: 'BRL',
  },
  {
    label: 'CAD',
    value: 'CAD',
  },
  {
    label: 'JPY',
    value: 'JPY',
  },
  {
    label: 'BTC',
    value: 'BTC',
  },
  {
    label: 'LTC',
    value: 'LTC',
  },
  {
    label: 'PYG',
    value: 'PYG',
  },
  {
    label: 'COP',
    value: 'COP',
  },
];

export default CURRENCIES;
